import { render, staticRenderFns } from "./LbCorpolateSubscPlanSubmit.vue?vue&type=template&id=0315e1d6&"
import script from "./LbCorpolateSubscPlanSubmit.vue?vue&type=script&lang=js&"
export * from "./LbCorpolateSubscPlanSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports